import React from "react";
import PropTypes from "prop-types";
import { ButtonComponentStyle } from "./ButtonComponentStyle";

const ButtonComponent = (props) => {
	/*
  The following function "buttonClicked" handles the event Button click.
  Implementation yet to be added
   */
	const buttonClicked = (e) => {
		if (props.onBtnClick) {
			e.preventDefault();
			props.onBtnClick(e);
		}
	};

	return (
		<>
			<button
				id={props.id}
				className={props?.isHidden ? "button-hide" : `${props?.className}`}
				uniquebuttonid={props?.uniqueButtonId}
				onClick={(e) => {
					buttonClicked(e);
				}}
				disabled={props?.disabledFlag}
			>
				{" "}
				<span
					id={props?.uniqueButtonId}
					className={`${props.textClassName} ${props.background} ${props?.disabledBtnClassName} buttonText`}
				>
					{props.selected ? props.selectedText : props.text}
				</span>
			</button>
			<style jsx>{ButtonComponentStyle}</style>
		</>
	);
};
ButtonComponent.propTypes = {
	text: PropTypes.string,
	showComponent: PropTypes.bool,
	pageRequired: PropTypes.string,
	onBtnClick: PropTypes.func,
	selected: PropTypes.bool,
	selectedText: PropTypes.string,
	sku: PropTypes.string,
	className: PropTypes.string,
	id: PropTypes.string,
	isHidden: PropTypes.bool,
	textClassName: PropTypes.string,
	uniqueButtonId: PropTypes.string,
	disabledFlag: PropTypes.bool,
	background: PropTypes.string,
	disabledBtnClassName: PropTypes.string,
};

ButtonComponent.defaultProps = {
	pageRequired: "/",
	className: "transparant-btn",
};

export default ButtonComponent;
